export default "__VITE_ASSET__Duo2aOzC__"